var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.formLocation === _vm.extraInfoLocation
        ? _c("div", { staticClass: "required row mx-0" }, [
            _vm._m(0),
            _vm._v(" "),
            _vm.showPropertyDetailsLink
              ? _c(
                  "div",
                  { staticClass: "col-6 px-0 text-right" },
                  [
                    _c("google-locate-button", {
                      attrs: { pageData: _vm.pageData }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.formInfo, function(info, key) {
        return _vm.isContentAvailable(info)
          ? _c(
              "div",
              {
                key: key,
                staticClass: "d-flex justify-content-center mx-auto mb-1"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "alert alert-primary my-0 py-2 w-50",
                    attrs: { role: "alert" }
                  },
                  [
                    _c("div", { staticClass: "row no-gutters" }, [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("div", {
                        staticClass:
                          "col d-inline-block my-auto smaller-font-content",
                        domProps: { innerHTML: _vm._s(_vm.infoContent(info)) }
                      })
                    ])
                  ]
                )
              ]
            )
          : _vm._e()
      })
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6 px-0 text-left" }, [
      _c("span", { staticClass: "star" }, [_vm._v("*")]),
      _vm._v("Required to run carrier quotes.\n    ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-474b4c0c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-474b4c0c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/presentational/widgets/FormInfo.vue
// module id = null
// module chunks = 